import { Injectable, OnDestroy } from '@angular/core';

import { filter, Observable, Subscription } from 'rxjs';

import { ConfigService } from '../../Core/Config/services/config.service';
import { ConfigModel } from '../../Core/Config/models/config.model';
import { CurrentUserStateService } from '../../Core/Users/services/current-user-state.service';
import { ServiceApi } from '../genericApi/service-api';
import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';
import { LocalizedEnumApiModel } from '../journodex/model/localized-enum-api.model';
import { CsvExportApiModel } from './model/csv-export.api.model';
import { EntityIdApiModel } from './model/entity-id-api-model';
import { TwitterInfoApiModel } from './model/twitter-info-api.model';
import { InteractionsExportApi } from './model/interactions-export.api';
import { EntityCountApi } from './model/entity-count.api';

@Injectable()
export class TargetingMiscApi implements OnDestroy {
    private usersSubscription: Subscription;
    private locale: string = 'en-US';
    private apiUrl: string;

    constructor(
        private serviceApi: ServiceApi,
        private configurationService: ConfigService,
        private currentUserStateService: CurrentUserStateService
    ) {
        const config: ConfigModel = this.configurationService.getConfig();

        this.apiUrl = config.apiUrl;

        this.usersSubscription = this.currentUserStateService.getDataReferenceLanguageTag().pipe(
            filter(x => !!x)
        ).subscribe(languageTag => {
            this.locale = languageTag;
        });
    }

    ngOnDestroy(): void {
        this.usersSubscription?.unsubscribe();
    }

    public csvExport(csvExportModel: CsvExportApiModel): Observable<string> {
        const slug: string = `/targeting/csvexport?locale=${this.locale}`;

        this.serviceApi.apiUrl = this.apiUrl;

        return this.serviceApi.api<string>(
            slug,
            csvExportModel,
            HttpVerbsEnum.POST,
            {},
            'text'
        );
    }

    public getCsvExportFields(): Observable<LocalizedEnumApiModel[]> {
        const slug: string = '/targeting/csvexport/fields';

        this.serviceApi.apiUrl = this.apiUrl;

        return this.serviceApi.api<LocalizedEnumApiModel[]>(
            slug,
            null,
            HttpVerbsEnum.GET
        );
    }

    public getTwitterInfo(ids: EntityIdApiModel[]): Observable<TwitterInfoApiModel[]> {
        const slug: string = '/targeting/twitterinfo';

        this.serviceApi.apiUrl = this.apiUrl;

        return this.serviceApi.api<TwitterInfoApiModel[]>(
            slug,
            ids,
            HttpVerbsEnum.POST
        );
    }

    public exportInteractions(interactionsExportModel: InteractionsExportApi): Observable<string> {
        const slug: string = `/targeting/csvexport/interactions?locale=${this.locale}`;

        this.serviceApi.apiUrl = this.apiUrl;

        return this.serviceApi.api<string>(
            slug,
            interactionsExportModel,
            HttpVerbsEnum.POST,
            {},
            'text'
        );
    }

    public getEntityCountForInteractionExport(interactionsExportModel: InteractionsExportApi): Observable<EntityCountApi> {
        const slug: string = '/targeting/csvexport/interactions/count';

        this.serviceApi.apiUrl = this.apiUrl;

        return this.serviceApi.api<EntityCountApi>(
            slug,
            interactionsExportModel,
            HttpVerbsEnum.POST
        );
    }
}
